module.exports = __webpack_public_path__ + "img/p8.c0bed131.svg";